import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FileService } from 'app/shared/file.service';
import { CreateEntityInput, EntityTypeEnum, FileTypeEnum, GetUserQuery, S3FileInput } from 'app/API.service';
import { IndustryEnumBeecher } from 'app/shared/enums/brownAndBrown.enum';
import { EntityService, RequiredStandard } from 'app/shared/entity.service';
import { UtilsService } from 'app/shared/utils.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { RiskOption } from 'models/generator.model';
import { NgbActiveModal, NgbDateStruct, NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'app/shared/user.service';
import { DomainFrameworkService } from 'app/shared/domain-framework.service';
import { FrameworkEnumTypes } from 'app/shared/enums/framework-enum-types.enum';
import { DomainFrameworksListingsComponent } from 'app/shared/domain-frameworks-listings/domain-frameworks-listings.component';
import { DeleteModalComponent } from 'app/shared/delete-modal/delete-modal.component';
import { UPPERDECK_FACELIFT } from 'app/shared/enums/shared.enum';
import { DEFAULT_SCORE_BASE, ScoreBaseOption, SCORING_BASE_OPTIONS } from 'app/shared/constant/scoreBase.constant';
import { ScoreService } from 'app/shared/score.service';

@Component({
  selector: 'cygov-add-client-modal',
  templateUrl: './add-client-modal.component.html',
  styleUrls: ['./add-client-modal.component.scss'],
  standalone: false,
})
export class AddClientModalComponent implements OnInit {
  @Output() modalResult = new EventEmitter<any>();
  @ViewChild(DomainFrameworksListingsComponent) domainFrameworksListingsComponent!: DomainFrameworksListingsComponent;
  isEditMode: boolean = false;
  currentEntity;
  newEntity;
  imageFile: any;
  riskFramework: RiskOption;
  s3Input: S3FileInput;
  standardList: RequiredStandard[];
  frameworkTypeOpt = [EntityTypeEnum.RISK_FRAMEWORK, EntityTypeEnum.COMPLIANCE_FRAMEWORK];
  displayStandardList: boolean;
  industryOpt: any = [];
  riskFrameWorkOpt: RiskOption[] = [];
  entityType: EntityTypeEnum;
  assessmentDate: Date;
  deadlineDate: Date;
  DEADLINE_DATE = 'deadlineDate';
  ASSESSMENT_DATE = 'assessmentDate';
  currentDate: NgbDateStruct;
  uploadedLogo: any;
  placeholderMandatory: string = 'Select Industry *';
  RiskFrameworkEnum: any;
  invalidInput: boolean = false;
  industryDropdown = {
    value: '',
    isDropDownOpened: false,
    list: [],
    searchList: [],
  };
  businessDropDown: boolean = false;
  solutionObject = {
    firstParty: { checked: true, name: '1st Party Full' },
    policyManagement: { checked: false, name: 'Policy Management', parent: 'firstParty' },
    regulatoryWatch: { checked: false, name: 'Regulatory Watch', parent: 'firstParty' },

    thirdParty: { checked: true, name: '3rd Party' },
    boardView: { checked: true, name: 'Boardview' },
  };
  solutionOrder: string[] = ['firstParty', 'policyManagement', 'regulatoryWatch', 'thirdParty', 'boardView'];
  //* Scoring Base Options *//
  currentScoringBase: number = DEFAULT_SCORE_BASE;
  scoringBaseOptions = SCORING_BASE_OPTIONS;
  isLoadingFrameworks: boolean = true;

  DomainScanValue = null;
  vendorList = [];
  ngbModalDeleteFrameworkOptions: NgbModalOptions = {
    size: 'sm',
    windowClass: 'delete-entity-modal delete-collection-framework-modal',
    backdropClass: 'delete-entity-backdrop-modal delete-collection-framework-backdrop-modal',
    backdrop: 'static',
  };

  constructor(
    private fileService: FileService,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private logger: NGXLogger,
    public activeModal: NgbActiveModal,
    private entityService: EntityService,
    private domainFrameworkService: DomainFrameworkService,
    private userService: UserService,
    private modalService: NgbModal,
    private scoreService: ScoreService
  ) {
    this.RiskFrameworkEnum = this.fileService.importFrameworkEnumsFromS3(FrameworkEnumTypes.RISK_FRAMEWORK_ENUM);
  }

  // Using canonical keys in solutionObject; no mapping helpers needed

  async ngOnInit(): Promise<void> {
    // TODO: Add input "Select Project Manager" it's mandatory. In the mean time it will be the current user
    const projectManager: GetUserQuery = await this.userService.getCurrentUser();
    const entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
    this.entityType = this.router.url.includes('clients') ? EntityTypeEnum.ROOT_ENTITY : EntityTypeEnum.CHILD_ENTITY;

    const industries = Object.keys(IndustryEnumBeecher);
    this.industryDropdown.list = industries
      .map(o => {
        return {
          name: IndustryEnumBeecher[o],
        };
      })
      .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

    this.industryDropdown.searchList = JSON.parse(JSON.stringify(this.industryDropdown.list));

    if (this.isEditMode) {
      this.newEntity = JSON.parse(JSON.stringify(this.currentEntity));
      this.newEntity.isCentraleyesApiEnabled = this.newEntity?.isCentraleyesApiEnabled ? true : false;
      const backendItems = this.newEntity?.solutionStatus?.items as Array<{
        key: string;
        enabled: boolean;
        parentKey?: string;
      }>;
      const getItemChecked = (key: string) => {
        const item = backendItems?.find(i => i.key === key);
        return item ? !!item.enabled : false;
      };
      this.solutionObject = {
        firstParty: {
          ...this.solutionObject.firstParty,
          checked: this.newEntity?.solutionStatus?.firstParty ?? true,
        },
        thirdParty: {
          ...this.solutionObject.thirdParty,
          checked: this.newEntity?.solutionStatus?.thirdParty ?? true,
        },
        boardView: { ...this.solutionObject.boardView, checked: this.newEntity?.solutionStatus?.boardView ?? true },
        policyManagement: {
          ...this.solutionObject.policyManagement,
          checked: getItemChecked('policyManagement'),
        },
        regulatoryWatch: {
          ...this.solutionObject.regulatoryWatch,
          checked: getItemChecked('regulatoryWatch'),
        },
      };
      this.initializeEntityScoreBase();
      if (Array.isArray(backendItems)) {
        backendItems.forEach(item => {
          const key = item.key;
          const enabled = !!item.enabled;
          const parentKey = item.parentKey;
          if (this.solutionObject[key]) {
            this.solutionObject[key].checked = enabled;
          } else {
            // Create missing child with a sensible default name
            this.solutionObject[key] = {
              checked: enabled,
              name: key,
              ...(parentKey ? { parent: parentKey } : {}),
            } as any;
            // Insert into solutionOrder right after its parent if exists
            const parentDisplayKey = parentKey;
            const parentIdx = this.solutionOrder.indexOf(parentDisplayKey);
            if (parentIdx >= 0) {
              // place immediately after the parent and after any existing siblings
              let insertIdx = parentIdx + 1;
              while (
                insertIdx < this.solutionOrder.length &&
                this.solutionObject[this.solutionOrder[insertIdx]]?.parent === parentDisplayKey
              ) {
                insertIdx += 1;
              }
              this.solutionOrder.splice(insertIdx, 0, key);
            } else if (!this.solutionOrder.includes(key)) {
              this.solutionOrder.push(key);
            }
          }
        });
      }
      if (!this.newEntity?.solutionStatus) {
        this.newEntity = {
          ...this.newEntity,
          solutionStatus: {
            firstParty: true,
            thirdParty: true,
            boardView: true,
          },
        };
      }

      if (!this.newEntity?.domainScanned) {
        this.newEntity.domainScanned = true;
        this.newEntity.domainScanEnabledForEntity = true;
      }
      if (this.newEntity?.domainScanTimes) {
        // this.DomainScanValue = JSON.parse(this.newEntity.domainScanTimes)[0].name;
        const domainScan = JSON.parse(this.newEntity.domainScanTimes);
        if (domainScan?.length) {
          this.DomainScanValue = domainScan[0].name;
          this.newEntity.domainScanned = true; // Enable domain scanned
          this.newEntity.domainScanEnabledForEntity = true; // Enable domain scan toggle
        }
      }
      this.industryDropdown.value = this.newEntity.industry;

      if (!this.newEntity?.AI || !Object.keys(this.newEntity.AI).length) {
        this.newEntity.AI = {
          credits: 100,
        };
      }

      if (!this.newEntity?.vendors || !Object.keys(this.newEntity.vendors).length) {
        this.newEntity.vendors = {
          vendorsTotalCount: 50,
        };
      }

      if (!this.newEntity?.regulatoryWatch || !Object.keys(this.newEntity.regulatoryWatch).length) {
        this.newEntity.regulatoryWatch = {
          credits: 25,
          usedCredits: 0,
        };
      }

      this.uploadedLogo = (await this.entityService.setLogoUrl(this.newEntity)).logoUrl;
    } else {
      this.newEntity = EntityService.initEntity(this.entityType, projectManager.id, entityId);
      this.newEntity.tierSelected = 4;
      this.newEntity.domainScanned = true;
      this.newEntity.domainScanEnabledForEntity = true;
      this.newEntity.domainScanTimes = null;
      this.newEntity.AI = { credits: 100 };
      this.newEntity.vendors = { vendorsTotalCount: 50, totalVendorsCreated: 0 };
      this.newEntity.regulatoryWatch = { credits: 25, usedCredits: 0 };
      this.newEntity.domainScanTimes = null;
      this.newEntity.solutionStatus = {
        firstParty: true,
        thirdParty: true,
        boardView: true,
      };
    }
    this.initializeEntityScoreBase();

    this.applyFrameworkSettings();
    // this.standardList = this.entityService.initStandardList();
    // this.displayStandardList = this.router.url.includes('multi-entity');
    // this.prepareRiskFrameworkOptions();
    this.currentDate = UtilsService.getDateInNgbDateStructFormat(new Date());
  }

  //* Initialize scoring base selection from entity data
  //* Sets currentScoringBase and updates scoringBaseOptions checked state
  private initializeEntityScoreBase(): void {
    // Determine the scoring base value: use entity's existing base or fall back to default
    const scoreBaseValue = this.newEntity?.scoringBase ?? DEFAULT_SCORE_BASE;
    this.currentScoringBase = scoreBaseValue;

    // Update checked state for all options - only one should be checked at a time
    this.scoringBaseOptions = this.scoringBaseOptions.map(opt => ({
      ...opt,
      checked: opt.value === scoreBaseValue,
    }));

    // Validate that at least one option is checked; if not, reset to default
    if (!this.scoringBaseOptions.some(opt => opt.checked)) {
      this.currentScoringBase = DEFAULT_SCORE_BASE;
      this.scoringBaseOptions = this.scoringBaseOptions.map(opt => ({
        ...opt,
        checked: opt.value === DEFAULT_SCORE_BASE,
      }));
    }
  }

  checkIfNewFrameworkAdded(domainFrameworks, entityFrameworks, entitySettingsExixts = true) {
    domainFrameworks.forEach(item => {
      // Check if the item from array1 is not present in array2
      const isInArray2 = entityFrameworks.some(obj => obj.name === item.name);
      // Add the object with status true to array2 if it's not already present
      if (!isInArray2 && item.status === true) {
        entityFrameworks.push({ ...item, status: entitySettingsExixts ? false : item.status });
      }
    });
    entityFrameworks = entityFrameworks.filter(
      item => domainFrameworks.some(obj => obj.name === item.name && obj.status === true) || item.status === true
    );
    return entityFrameworks;
  }
  // eslint-disable-next-line @typescript-eslint/require-await
  applyFrameworkSettings() {
    try {
      let frameworkSettings = null;
      if (this.isEditMode) {
        frameworkSettings = this.newEntity?.frameworkSettings ? JSON.parse(this.newEntity?.frameworkSettings) : null;
        const domainSettings = this.domainFrameworkService.domainSettingsData;
        frameworkSettings = {
          RISK_FRAMEWORKS: this.checkIfNewFrameworkAdded(
            domainSettings?.RISK_FRAMEWORKS || [],
            frameworkSettings?.RISK_FRAMEWORKS || [],
            frameworkSettings?.RISK_FRAMEWORKS.length ? true : false
          ),
          COMPLIANCE_FRAMEWORKS: this.checkIfNewFrameworkAdded(
            domainSettings?.COMPLIANCE_FRAMEWORKS || [],
            frameworkSettings?.COMPLIANCE_FRAMEWORKS || [],
            frameworkSettings?.COMPLIANCE_FRAMEWORKS.length ? true : false
          ),
          VENDOR_FRAMEWORKS: this.checkIfNewFrameworkAdded(
            domainSettings?.VENDOR_FRAMEWORKS || [],
            frameworkSettings?.VENDOR_FRAMEWORKS || [],
            frameworkSettings?.VENDOR_FRAMEWORKS.length ? true : false
          ),
        };
      }
      if (!frameworkSettings) {
        frameworkSettings = this.domainFrameworkService.domainSettingsData;
      }
      // risk
      this.riskFrameWorkOpt = [
        ...frameworkSettings.RISK_FRAMEWORKS.filter(vendorFramework => {
          if (this.isEditMode) {
            return true;
          } else {
            return !!vendorFramework.status;
          }
        }),
      ];
      // compliance
      this.standardList = [
        ...frameworkSettings.COMPLIANCE_FRAMEWORKS.filter(vendorFramework => {
          if (this.isEditMode) {
            return true;
          } else {
            return !!vendorFramework.status;
          }
        }),
      ];
      this.vendorList = [
        ...frameworkSettings.VENDOR_FRAMEWORKS.filter(vendorFramework => {
          if (this.isEditMode) {
            return true;
          } else {
            return !!vendorFramework.status;
          }
        }),
      ];
      this.isLoadingFrameworks = false;
    } catch (error) {
      this.isLoadingFrameworks = false;
      console.log({ error });
    }
  }

  // prepareRiskFrameworkOptions(): void {
  //   const riskList =
  //     UtilsService.isBnB || UtilsService.isBnBCyberSite
  //       ? [this.RiskFrameworkEnum.NIST_CSF_BB.split(' ').join('_')]
  //       : Object.keys(this.RiskFrameworkEnum);
  //   for (const enumMember of riskList) {
  //     this.riskFrameWorkOpt.push({
  //       key: enumMember,
  //       value: this.RiskFrameworkEnum[enumMember],
  //     });
  //   }
  // }

  toggleStandard(event, standard: RequiredStandard): void {
    UtilsService.stopBubbling(event);
    standard.checked = !standard.checked;
  }

  async imgHandler(eventFile: Event): Promise<void> {
    try {
      const value = await this.fileService.verifyUploadFile(eventFile, FileTypeEnum.LOGO);
      if (!value) {
        return;
      }
      this.s3Input = await this.fileService.convertToS3Input(eventFile, this.newEntity.id);
      this.uploadedLogo = await this.fileService.getUploadedImg(eventFile);
    } catch (error) {
      this.logger.error('Image Handler  Error =', error);
      this.toastrService.error(error);
      // eventFile = null;
      // this.s3Input = null;
      // this.uploadedLogo = previousLogo;
    }
  }

  isValid(entity: CreateEntityInput): boolean {
    let valid = true;
    if (!entity.name) {
      this.toastrService.error('Entity name is required');
      valid = false;
    } else if (UtilsService.checkForHtml(entity.name)) {
      this.toastrService.error('HTML tags are not allowed in the entity name');
      valid = false;
    } else {
      if (entity.name.length > 30) {
        this.toastrService.error('Entity name cannot exceed 30 characters');
        valid = false;
      }
    }
    if (this.entityType === EntityTypeEnum.ROOT_ENTITY) {
      if (!entity.industry) {
        this.toastrService.error('Entity Industry is required');
        valid = false;
      }
    }
    return valid;
  }

  dateChanged(date, dateType: string): void {
    this[dateType] = date;
  }

  emitEntity(groupedFrameworks): void {
    const updatedSettings = {
      RISK_FRAMEWORKS: groupedFrameworks.RISK_FRAMEWORKS,
      COMPLIANCE_FRAMEWORKS: groupedFrameworks.COMPLIANCE_FRAMEWORKS,
      VENDOR_FRAMEWORKS: groupedFrameworks.VENDOR_FRAMEWORKS,
    };
    const filterRisk = updatedSettings.RISK_FRAMEWORKS.filter(risk => risk.status === true);
    if (filterRisk.length === 0) {
      this.toastrService.error('Select at least one Risk Framework');
      return;
    }
    if (this.newEntity.solutionStatus.thirdParty === true) {
      const filterVendor = updatedSettings.VENDOR_FRAMEWORKS.filter(risk => risk.status === true);
      if (filterVendor.length === 0) {
        this.toastrService.error('Select at least one Vendor Framework');
        return;
      }
    }
    this.entityService.updateIsLoading(true);
    this.newEntity.frameworkSettings = JSON.stringify(updatedSettings);
    this.newEntity.domainScanTimes = JSON.stringify(
      this.DomainScanValue ? [{ name: this.DomainScanValue, created: Date.now(), updated: Date.now() }] : []
    );

    if (!JSON.parse(this.newEntity.domainScanTimes)?.length && this.newEntity?.domainScanStatus) {
      delete this.newEntity.domainScanStatus;
    }

    this.newEntity.upperdeckSetting = this.newEntity.domainScanEnabledForEntity
      ? UPPERDECK_FACELIFT.RESIDUAL_RISK_ATTACK_SURFACE
      : UPPERDECK_FACELIFT.RESIDUAL_RISK;

    const items = Object.keys(this.solutionObject)
      .filter(key => !!(this.solutionObject as any)[key]?.parent)
      .map(key => ({
        key,
        enabled: !!(this.solutionObject as any)[key].checked,
        parentKey: (this.solutionObject as any)[key].parent,
      }));

    this.newEntity.solutionStatus = {
      ...this.newEntity.solutionStatus,
      items,
    };

    //* check if the score base is set, if not set to default
    if (!this.newEntity?.scoringBase) {
      this.newEntity.scoringBase = DEFAULT_SCORE_BASE;
    }

    //* Update score service cache with the entity's scoring base */
    this.scoreService.updateEntityScoreBaseInCache(
      this.newEntity.id,
      this.newEntity?.scoringBase || DEFAULT_SCORE_BASE
    );

    this.modalResult.emit({
      entity: this.newEntity,
      s3Input: this.s3Input,
      requiredStandard: [],
    });
  }

  openBusinessDropdown(obj: any): void {
    obj.isDropDownOpened = !obj.isDropDownOpened;
    this.businessDropDown = obj.isDropDownOpened;
    if (obj.isDropDownOpened) {
      this.industryDropdown.searchList = JSON.parse(JSON.stringify(this.industryDropdown.list));
      const modalEl = document.querySelector('.add-client-modal-windowClass');
      if (modalEl) {
        modalEl.classList.add('dropdown-open');
      }
    } else {
      const modalEl = document.querySelector('.add-client-modal-windowClass');
      if (modalEl) {
        modalEl.classList.remove('dropdown-open');
      }
    }
  }

  saveBusinessDropdownItem(obj: any, index: number): void {
    obj.isDropDownOpened = false;
    this.businessDropDown = false;
    const modalEl = document.querySelector('.add-client-modal-windowClass');
    if (modalEl) {
      modalEl.classList.remove('dropdown-open');
    }
    obj.value = obj.searchList[index].name;
    this.newEntity.industry = obj.value;
  }
  searchInDropdownList(event) {
    const inputText = (event.target as HTMLInputElement).value;
    this.industryDropdown.searchList = JSON.parse(
      JSON.stringify(
        this.industryDropdown.list.filter(item => item.name.toLowerCase().includes(inputText.toLocaleLowerCase()))
      )
    );
  }

  closeBusinessDetailDropdown(): void {
    this.industryDropdown.isDropDownOpened = false;
    this.businessDropDown = false;
    const modalEl = document.querySelector('.add-client-modal-windowClass');
    if (modalEl) {
      modalEl.classList.remove('dropdown-open');
    }
  }
  beforeCheckBoxChnaged(event) {
    const checkboxId = (event.target as HTMLInputElement).id;
    if (
      checkboxId === 'firstParty' &&
      this.solutionObject[checkboxId].checked &&
      !this.solutionObject.thirdParty.checked
    ) {
      event.preventDefault();
    }

    if (
      checkboxId === 'thirdParty' &&
      this.solutionObject[checkboxId].checked &&
      !this.solutionObject.firstParty.checked
    ) {
      event.preventDefault();
    }

    if (
      (checkboxId === 'policyManagement' || checkboxId === 'regulatoryWatch') &&
      this.solutionObject[checkboxId].checked &&
      !this.solutionObject.firstParty.checked
    ) {
      event.preventDefault();
    }
  }

  checkboxChangeHandler(event, item) {
    if (item.key === 'boardView') {
      this.solutionObject.firstParty.checked = event === false ? this.solutionObject.firstParty.checked : true;
      this.newEntity.solutionStatus.firstParty = this.solutionObject.firstParty.checked;
      this.solutionObject.boardView.checked = event;
      this.newEntity.solutionStatus.boardView = event;
    } else if (item.key === 'firstParty') {
      this.newEntity.solutionStatus.firstParty = event;
      this.newEntity.domainScanned = event === false ? false : true;
      this.newEntity.domainScanEnabledForEntity = this.newEntity.domainScanned;
      this.DomainScanValue = this.newEntity.domainScanEnabledForEntity ? this.DomainScanValue : '';
      this.newEntity.solutionStatus.boardView = event === false ? false : this.newEntity.solutionStatus.boardView;
      this.solutionObject.boardView.checked = this.newEntity.solutionStatus.boardView;
      if (event === false) {
        this.solutionObject.policyManagement.checked = false;
        this.solutionObject.regulatoryWatch.checked = false;
      }
    } else {
      if (item.key === 'thirdParty') {
        this.newEntity.solutionStatus.thirdParty = event;
      }
    }
    item.value.checked = event;
  }

  scoringBaseChangeHandler(event: any, option: ScoreBaseOption): void {
    this.currentScoringBase = option.value;
    this.scoringBaseOptions.forEach(opt => (opt.checked = opt.value === this.currentScoringBase));
    this.newEntity.scoringBase = this.currentScoringBase;
  }

  increment(label: string, inputField: HTMLInputElement) {
    let currentValue = parseFloat(inputField.value);

    // Add the same value to the current input value
    if (label === 'AI_CREDITS') {
      currentValue = this.newEntity.AI.credits + 100;
      this.newEntity.AI.credits = currentValue;
    } else if (label === 'VENDORS_COUNT') {
      currentValue = this.newEntity.vendors.vendorsTotalCount + 50;
      this.newEntity.vendors.vendorsTotalCount = currentValue;
    } else if (label === 'REGULATIONS_COUNT' && this.newEntity?.regulatoryWatch) {
      currentValue = this.newEntity.regulatoryWatch.credits + 1;
      this.newEntity.regulatoryWatch.credits = currentValue;
    }
    // Update the input field's value
    inputField.value = currentValue.toString();
  }

  onRegulationsCountChange(inputField: HTMLInputElement): void {
    const value = parseInt(inputField.value, 10);
    if (!isNaN(value) && value >= 25 && this.newEntity?.regulatoryWatch) {
      this.newEntity.regulatoryWatch.credits = value;
      inputField.value = value.toString();
    } else {
      inputField.value = (this.newEntity?.regulatoryWatch?.credits ?? 25).toString();
    }
  }

  decrement(label: string, inputField: HTMLInputElement) {
    let currentValue = parseFloat(inputField.value);

    // Subtract the same value from the current input value
    if (label === 'AI_CREDITS' && currentValue > 100) {
      currentValue = this.newEntity.AI.credits - 100;
      this.newEntity.AI.credits = currentValue;
    } else if (label === 'VENDORS_COUNT' && currentValue > 50) {
      currentValue = this.newEntity.vendors.vendorsTotalCount - 50;
      this.newEntity.vendors.vendorsTotalCount = currentValue;
    } else if (label === 'REGULATIONS_COUNT' && currentValue > 25 && this.newEntity?.regulatoryWatch) {
      currentValue = this.newEntity.regulatoryWatch.credits - 1;
      this.newEntity.regulatoryWatch.credits = currentValue;
    }
    // Update the input field's value
    inputField.value = currentValue.toString();
  }

  saveButtonClicked() {
    this.domainFrameworksListingsComponent.saveButtonEventHandler();
  }

  deleteClientModal() {
    const message = this.router.url.includes('clients') ? 'Entity' : 'Sub Entity';
    const modalRef = this.modalService.open(DeleteModalComponent, this.ngbModalDeleteFrameworkOptions);
    modalRef.componentInstance.titleText = '';
    modalRef.componentInstance.show2ndConfirmText = 'All your data will be lost';
    modalRef.componentInstance.removeLabelText = this.newEntity.name;
    modalRef.componentInstance.deleteEntityModal = true;
    modalRef.componentInstance.svgName = 'trash-icon';
    modalRef.componentInstance.entityType = message.toLowerCase() === 'entity' ? message.toLowerCase() : 'sub-entity';
    modalRef.componentInstance.deleteFramework.subscribe((deleteConfirm: boolean) => {
      if (deleteConfirm) {
        this.modalResult.emit('delete');
      }
    });
  }
}
